import type BigNumber from 'bignumber.js';

import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { TextButton } from '@flipster/react/design-system/text-button';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { center, stack } from '@flipster/styled-system/patterns';

export const CrossMarginTooltipContent = ({ collateralRate }: { collateralRate: BigNumber | undefined }) => {
  const router = useRouter();
  return (
    <div className={stack({ gap: 10 })}>
      <div
        className={center({
          p: 16,
          rounded: 8,
          bg: 'background.default.level-1',
        })}
      >
        <p className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
          <FormattedMessage
            id='Earn.r260203.Percent_of_subscribed_balance'
            values={{
              percent: <Formatted.Percent key='percent' value={collateralRate} isRate precision={2} />,
            }}
          />
        </p>
      </div>
      <p
        className={css({
          textStyle: 'Text/M/Monospace/Regular',
          whiteSpace: 'pre-line',
        })}
      >
        <FormattedMessage id='Earn.r260304.Avail_for_cross_margin_tooltip_description' />
      </p>
      <TextButton
        label={<FormattedMessage id='Autogen_common.r251126.s_Learn_more' />}
        onClick={() => {
          router.push('/collateral-overview');
        }}
        css={{ alignSelf: 'flex-start' }}
      />
    </div>
  );
};
